import useDarkModeLib from "use-dark-mode";

const useDarkMode = () => {
  try {
    return useDarkModeLib(false);
  } catch (e) {
    // localStorage is not available
    return false;
  }
};

export default useDarkMode;
